import { render, staticRenderFns } from "./SendMessageIcon.vue?vue&type=template&id=f15b94a2"
import script from "./SendMessageIcon.vue?vue&type=script&lang=ts"
export * from "./SendMessageIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports